// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__tUGfO","content":"styles_content__1ULca","selectAll":"styles_selectAll__3p53e"};